import oRequest from '@/libsV2/request.js';
import store from '@/store/store';

const getData = (url, data,type = true) => {
    // if (type) {
    //     store.commit("loadSwitch", true);
    // }
    return oRequest.getData(url, data).then(res => {
        // if (type) {
        //     store.commit("loadSwitch", false);
        // }
        return res.data
    })
}
export const shareNum = (data,type) => {
    return getData('project/discuss/addShareNum', data,type)
}
export const readNum = (data,type) => {
    if (store.state.shareUserId) {
        data = {...data,share_user_id:store.state.shareUserId}
    }
    return getData('project/discuss/addReadNum', data,type)
}
export const getEvaluationInfo = (data,type) => {
    return getData('project/discuss/poster_dis', data,type)
}
export const getEvaPoster = (data,type) => {
    return getData('project/discuss/poster', data,type)
}
export const getReport = (data,type) => {
    return getData('member/process/infov2', data,type)
}
